import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { CheckoutLayout } from 'common/components/layout';

import HoldCancelClubMembership from '../holdCancel/HoldCancelClubMembership';

import ClubMembershipInfo from './ClubMembershipInfo';
import Header from './Header';
import ClubSubscriptionInfo from './components/subscription/ClubSubscriptionInfo';
import MobileToggleSummary from './components/subscription/MobileToggleSummary';
import ShipmentSummary from './components/subscription/ShipmentSummary';

const SubscriptionShipment = (props) => {
  const { clubMembership } = props;

  const [isSummaryVisibleOnMobile, setIsSummaryVisibleOnMobile] =
    useState(true);

  const toggleMobileSummary = () => {
    setIsSummaryVisibleOnMobile(!isSummaryVisibleOnMobile);
  };

  const settings = useSelector((state) => state.setting);
  const clubMembershipReducer = useSelector((state) => state.clubMembership);
  const clubSubscriptionShipmentReducer = useSelector(
    (state) => state.clubSubscriptionShipment
  );
  const clubReducer = useSelector((state) => state.club);

  if (!settings.data || !clubMembershipReducer.data) {
    return (
      <CheckoutLayout title="Club Shipment" loading>
        &nbsp;
      </CheckoutLayout>
    );
  }

  if (!clubMembership.activeClubSubscriptionShipmentId) {
    return <Redirect to="/profile/club-membership" />;
  }
  const clubSubscriptionShipment =
    clubSubscriptionShipmentReducer.data[
      clubMembership.activeClubSubscriptionShipmentId
    ];
  const club = clubReducer.data[clubMembership.clubId];
  return (
    <CheckoutLayout title="Club Shipment">
      <MobileToggleSummary
        clubSubscriptionShipment={clubSubscriptionShipment}
        onToggleMobile={toggleMobileSummary}
      />
      <div className="c7-checkout">
        <ShipmentSummary
          isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
          clubSubscriptionShipment={clubSubscriptionShipment}
          club={club}
        />

        <div className="c7-checkout__main c7-checkout__main--wide">
          <Header clubMembership={clubMembership} />
          <div className="c7-checkout__content">
            <ClubMembershipInfo clubMembership={clubMembership} />
            <br />
            <ClubSubscriptionInfo
              clubSubscriptionShipment={clubSubscriptionShipment}
              club={club}
            />
          </div>
          <HoldCancelClubMembership
            clubMembership={clubMembership}
            clubSubscriptionShipment={clubSubscriptionShipment}
          />
        </div>
      </div>
    </CheckoutLayout>
  );
};

export default SubscriptionShipment;
